import React, { useState } from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { useWindowDimension } from '../../../hooks/windowDimensions';
import CustomModal from '../../eir-porting/CustomModal/CustomModal';
import CustomUpdatedPopUpModal from '../../eir-porting/CustomModal/CustomUpdatedPopUpModal';
import CustomTextField from '../../../sharedcomponents/inputs/text-field/CustomTextField';
import useStyles from './style';
import success from '../.././images/Large-icon-Success.png';
import { useApolloClient } from '@apollo/client';
import MyEirErrorHandle from '../../eir-porting/MyEirErrorHandle';
import { handleActivateSim } from './simReplacement.util';
import EirButton from '../../../theme/EirButton';

const MyEirActivateSimReplacementContainer = props => {
    const classes = useStyles();
    const serviceId = props.serviceId;
    const [open, setOpenModal] = useState(false);
    const [code, setCode] = useState('');
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [validcode, setValidcode] = useState(false);
    const [invalidOtp, setInvalidOtp] = useState('');
    const [openError, setOpenError] = useState(false);
    const [openCustomPopup, setOpenCustomPopup] = useState(false);
    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });
    const [width, height] = useWindowDimension();
    const graphql = useApolloClient();
    const [simIn, setData] = useState({
        puk: '',
        serviceId: '',
    });

    // API Integration
    const handleActivateSimUtil = async () => {
        await handleActivateSim({
            graphql,
            serviceId,
            code,
            setData,
            setOpenCustomPopup,
            setOpenError,
            openError,
        });
    };

    // open modal
    const handleOpen = () => {
        setOpenModal(!open);
    };

    //submit action
    const handleActivateSimCta = () => {
        handleActivateSimUtil();
        setEnableSubmit(true);
        setCode('');
        setValidcode(false);
        setOpenModal(!open);
    };

    const handleValidcode = e => {
        const codeValue = e.target.value;
        setCode(codeValue);
        setValidcode(true);
        // when input is empty
        if (codeValue === '') {
            setInvalidOtp('Please enter puk code');
            setValidcode(false);
        } else if (codeValue.length !== 8) {
            setInvalidOtp('Must be 8 characters long');
            setValidcode(false);
        } else {
            setInvalidOtp('');
            setCode(codeValue);
        }
    };
    // handle back arrow action
    const backArrowAction = () => {
        setOpenModal(!open);
        setCode('');
        setValidcode(false);
        setInvalidOtp('');
    };

    const handleTogglePopup = () => {
        setOpenCustomPopup(!openCustomPopup);
    };

    const handleAltCta = () => {
        setOpenCustomPopup(false);
    };

    return (
        <Box id='sim-replacement'>
            <Typography
                onClick={handleOpen}
                className={classes.activateSim}
                tabIndex={0}
                onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === '') {
                        e.preventDefault();

                        handleOpen();
                    }
                }}
                aria-label='Activate replacement SIM'
            >
                Activate replacement SIM
            </Typography>
            <CustomModal
                open={open}
                header={{
                    text: 'Activate your Replacement SIM',
                    arrowAction: backArrowAction,
                    center: false,
                }}
                description='Enter PUK code below. This can be found on the replacement SIM pack you
                    received.'
                cta1={cta1}
                cta2={cta2}
                ariaLabel='Activate your Replacement SIM opens popup'
            >
                <Typography className={classes.textContainer}>
                    Enter PUK code below. This can be found on the replacement SIM pack you
                    received.
                </Typography>
                <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <Box className={classes.textFieldotp}>
                        <CustomTextField
                            id='Your PUK code'
                            label='Your PUK code'
                            onChange={handleValidcode}
                            className={`validcode`}
                            value={code}
                            classes={{
                                container: `${classes.textField}`,
                            }}
                            // value={code}
                            inputProps={{
                                maxLength: 8,
                            }}
                            error={Boolean(invalidOtp)}
                            errorMessage={invalidOtp}
                        />
                    </Box>
                    {width < 600 ? (
                        <EirButton
                            onClick={handleActivateSimCta}
                            // bgColor={validcode ? 'primary' : 'default'}
                            // className={`${validcode ? classes.cta1 : classes.ctaDisable1}`}
                            variants='primaryButtonMedium'
                            style={{ padding: '0.5rem 2rem' }}
                            disabled={!validcode}
                            role='button'
                        >
                            Activate SIM
                        </EirButton>
                    ) : (
                        <EirButton
                            onClick={handleActivateSimCta}
                            // bgColor={validcode ? 'primary' : 'default'}
                            // className={`${validcode ? classes.cta1 : classes.ctaDisable1}`}
                            variants='primaryButtonMedium'
                            style={{ padding: '0.5rem 2rem' }}
                            disabled={!validcode}
                            role='button'
                        >
                            Activate SIM
                        </EirButton>
                    )}
                </Box>
            </CustomModal>
            <Box id='my-eir-pop-up'>
                <CustomUpdatedPopUpModal
                    open={openCustomPopup}
                    toggle={handleTogglePopup}
                    cta1={{ text: 'Close', action: handleAltCta, disable: false }}
                    cta2={{ text: '', action: () => {} }}
                >
                    <Box className={classes.successPopup}>
                        <Box className={classes.successImg}>
                            <Typography component='img' src={success} alt='' />
                        </Box>

                        <Typography className={classes.imgTextAdditional}>
                            Your new SIM is activated
                        </Typography>
                    </Box>
                </CustomUpdatedPopUpModal>
            </Box>
            {openError ? <MyEirErrorHandle open={openError} setOpen={setOpenError} /> : ''}
        </Box>
    );
};

export default MyEirActivateSimReplacementContainer;
